<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <b-form-checkbox
      :checked="field_value"
      :disabled="is_disabled"
      :label="field_label"
      @input="button_pressed"
      v-bind="field.params"
      v-if="layout == 'checkbox'"
    ></b-form-checkbox>

    <b-form-checkbox
      :checked="field_value"
      :disabled="is_disabled"
      :label="field_label"
      @input="button_pressed"
      switch
      v-bind="field.params"
      v-if="layout == 'switch'"
    ></b-form-checkbox>

    <div v-if="layout == 'buttons'">
      <b-button
        :disabled="is_disabled"
        :value="true"
        :variant="yesColor"
        @click="button_pressed(true)"
      >
        <checkbox-outline-icon v-if="field_value == true" />
        {{ yesLabel }}
      </b-button>

      <b-button
        :disabled="is_disabled"
        :value="false"
        :variant="noColor"
        @click="button_pressed(false)"
      >
        <checkbox-outline-icon v-if="field_value == false" />
        {{ noLabel }}
      </b-button>

      <b-button
        :disabled="is_disabled"
        :value="null"
        :variant="naColor"
        @click="button_pressed(null)"
        v-if="field.params.allow_na"
      >
        <checkbox-outline-icon v-if="isNullValue" />
        {{ naLabel }}
      </b-button>
    </div>

    <b-form-radio-group
      :disabled="is_disabled"
      v-if="layout == 'radios'"
      :checked="field_value_str"
    >
      <b-form-radio @change="button_pressed(true)" value="yes">{{
        yesLabel
      }}</b-form-radio>
      <b-form-radio @change="button_pressed(false)" value="no">{{
        noLabel
      }}</b-form-radio>
      <b-form-radio
        @change="button_pressed(null)"
        value="na"
        v-if="field.params.allow_na"
        >{{ naLabel }}
      </b-form-radio>
    </b-form-radio-group>
  </f-form-group>
</template>

<script>
import { setter } from "../setter";
import FormWidgetMixin from "../FormWidgetMixin.js";
import FFormGroup from "../FFormGroup.vue";
import CheckboxOutlineIcon from "vue-material-design-icons/CheckBoxOutline.vue";

export default {
  name: "CheckboxWidget",
  components: { FFormGroup, CheckboxOutlineIcon },
  mixins: [FormWidgetMixin],
  methods: {
    button_pressed: function (value) {
      this.on_input(value);
    },
  },
  computed: {
    layout() {
      return this.field.params.layout || "checkbox";
    },
    yesLabel: function () {
      return this.field.params.yesLabel || "Yes";
    },
    yesColor: function () {
      if (this.field_value === true) {
        if (this.field.params.yesColor) {
          return this.field.params.yesColor;
        }

        return "success";
      }

      return "";
    },
    noLabel: function () {
      return this.field.params.noLabel || "No";
    },
    noColor: function () {
      if (this.field_value === false) {
        if (this.field.params.noColor) {
          return this.field.params.noColor;
        }

        return "danger";
      }

      return "";
    },
    naLabel: function () {
      return this.field.params.naLabel || "N/A";
    },
    naColor: function () {
      if (this.isNullValue) {
        if (this.field.params.naColor) {
          return this.field.params.naColor;
        }

        return "warning";
      }

      return "";
    },
    isNullValue: function () {
      return this.has_value && this.field_value === null;
    },
    field_value_str: function () {
      if (this.has_value) {
        if (this.field_value === true) {
          return "yes";
        }
        if (this.field_value === false) {
          return "no";
        }
        if (this.field_value === null) {
          return "na";
        }
      }
      return "";
    },
  },
  watch: {
    defaultValue: {
      handler() {
        if (this.item && this.field) {
          setter(this, this.item, this.field.code, this.field.default_value);
        }
      },
      deep: true,
    },
  },
};
</script>
